/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Ref_N4Inputs */

const en_diff_ref_n4 = /** @type {(inputs: Diff_Ref_N4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Object keys are joined with dots, at any depth.`)
};

const ko_diff_ref_n4 = /** @type {(inputs: Diff_Ref_N4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`객체 키는 깊이와 무관하게 점으로 이어집니다.`)
};

const ja_diff_ref_n4 = /** @type {(inputs: Diff_Ref_N4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オブジェクトキーは深さに関係なくドットでつながれます。`)
};

/**
* | output |
* | --- |
* | "Object keys are joined with dots, at any depth." |
*
* @param {Diff_Ref_N4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_ref_n4 = /** @type {((inputs?: Diff_Ref_N4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Ref_N4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_ref_n4(inputs)
	if (locale === "ko") return ko_diff_ref_n4(inputs)
	return ja_diff_ref_n4(inputs)
});